module.exports = __webpack_public_path__ + "img/icon-list.3b639d81.svg";